import { Component, Input, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ProfileModel } from "src/app/models/profile.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { ContextService } from "src/app/services/context/context.service";
import { DateService } from "src/app/services/date/date.service";
import { HomeService } from "src/app/services/home-service/home.service";
import { MathService } from "src/app/services/math/math.service";
import { UtilsService } from "src/app/services/utils/utils.service";

@Component({
  selector: "sales-list",
  templateUrl: "./sales-list.component.html",
  styleUrls: ["./sales-list.component.scss"]
})
export class SalesListComponent implements OnInit {
  @Input()
  tournees: TourneeModel[];

  @Input()
  tourneesByMonthYear:any;

  @Input()
  sortBy: string;

  @Input()
  mode: string; // consumer, producer

  @Input()
  title: string;

  @Input()
  subtitle: string;

  @Input()
  footer: string;

  @Input()
  showMap = true;

  @Input()
  viewer: ProfileModel;

  @Input()
  tourneesByType = new BehaviorSubject({ week: {}, owner: {}, type: {}, all: [] });


  loading = false;

  statusToColor = {
    draft: "tertiary",
    open: "secondary",
    full: "primary",
    prepared: "primary",
    distributing: "primary",
    delivered: "primary",
    cancelled: "primary",
    closed: "primary"
  };

  constructor(public dateService: DateService, public mathService: MathService, private homeService: HomeService, public contextService: ContextService, public utils:UtilsService) {
  }

  ngOnInit() {}

  ngOnDestroy() {}

  open(item: TourneeModel) {
    console.log(item.details.format,this.mode, item, this.viewer.key);
    if(this.mode =='producer'){
      if (item.market) {
        this.homeService.navigateToMyMarket(item.market, this.viewer.key);
      } 
      else if (item.details.format == "group") {
        this.homeService.navigateToMarket(item);
      } else {
        this.homeService.navigateToMySale(item);
      }
    }
    else if(item.status =='open'){
      if (item.details.format == "group") {
        this.homeService.navigateToMarket(item);
      } else {
        this.homeService.navigateToSale(item);
      }
    }
  }
}
